import { render, staticRenderFns } from "./viewNoticeDetail.vue?vue&type=template&id=75240ce1&scoped=true"
import script from "./viewNoticeDetail.vue?vue&type=script&lang=js"
export * from "./viewNoticeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75240ce1",
  null
  
)

export default component.exports